import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { APP_NAME } from "@/lib/app";
import { useLang } from "@/i18n";
import { useCamp } from "@/context/SettingsContext";

// Handelsmerk-intro: zwart scherm, campingnaam groot met CampAd Pro klein eronder (3.6s, daarna 1s uitfaden)
export default function IntroScreen({ onDone }) {
  const [show, setShow] = useState(true);
  const { t } = useLang();
  const { camp } = useCamp();
  useEffect(() => {
    const id = setTimeout(() => { setShow(false); onDone && onDone(); }, 3600);
    return () => clearTimeout(id);
  }, [onDone]);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-screen"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        >
          <motion.div
            className="logo-wordmark text-white text-center px-6 text-xl sm:text-3xl md:text-4xl select-none uppercase"
            initial={{ opacity: 0, letterSpacing: "0.9em", scale: 0.96 }}
            animate={{ opacity: 1, letterSpacing: "0.42em", scale: 1 }}
            transition={{ duration: 1.6, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            data-testid={camp.camp_name ? "intro-camp-name" : "intro-app-name"}
          >
            {camp.camp_name || APP_NAME}
          </motion.div>
          <motion.p
            className="mt-6 text-[11px] sm:text-xs tracking-[0.5em] text-white/45 uppercase"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2, delay: 1.4 }}
            data-testid={camp.camp_name ? "intro-app-name-small" : "intro-tagline"}
          >
            {camp.camp_name ? APP_NAME : t("tagline")}
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
